import { render, staticRenderFns } from "./AccidentStatisticsIndex.vue?vue&type=template&id=e4bc3b3c&scoped=true&"
import script from "./AccidentStatisticsIndex.vue?vue&type=script&lang=js&"
export * from "./AccidentStatisticsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4bc3b3c",
  null
  
)

export default component.exports